import { jsx, css } from '@emotion/react';
import styled from '@emotion/styled';
import _ from 'lodash';

import { useFeatures } from './features';
import Text from '../../OC/oc-text';
import { connectLocation } from '../../location/LocationConnectors';

const FeatureFlags = styled.div`
  display: flex;
  justify-content: flex-end;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;

  .feature-flag {
    height: 50px;
    width: auto;

    &:nth-child(2) {
      margin-left: 5px;
    }
  }
`;

const FlagWithText = styled.div`
  align-items: center;
  background: #d40f7d;
  display: flex;
  justify-content: center;

  span {
    color: white !important;
    margin: auto 0.4em;
    text-transform: uppercase;
  }
`;

const FeatureSubImage = ({ t, item, feature = {} }) => {
  const { key: featureKey, flagStyle = {} } = feature;
  const translateScoped = key => {
    const translation = t(`shingles.features.${featureKey}.${key}`);
    return translation?.startsWith('MISSING: ') ? null : translation;
  };

  // preference is translated icon > translated text > feature.flagIcon > feature.icon
  let flagIcon = translateScoped('flag_icon');
  const flagText = translateScoped('flag_text');
  let flagAlt = translateScoped('alt');

  const attrs = feature.itemAttributes(item);
  if (attrs) {
    flagIcon = attrs.flagIcon;
    flagAlt = attrs.flagAlt;
  } else if (!flagText) {
    // only continue looking for flagIcon if we didn't get a text
    flagIcon ||= feature.flagIcon;
    flagIcon ||= feature.icon;
    flagAlt ||= feature.alt;
  }

  if (flagIcon) {
    return <img alt={flagAlt} className={`feature-flag ${featureKey}`.trim()} style={flagStyle} src={flagIcon} />;
  }
  return (
    <FlagWithText style={flagStyle}>
      <Text content={flagText} />
    </FlagWithText>
  );
};

export const FeatureImage = connectLocation(({ t, item, featuresSubset = [], className, ...props }) => {
  const allRoofingFeatures = useFeatures();

  if (!allRoofingFeatures) {
    return null;
  }

  const shingleFeatures = [];
  let consideredFeatures = allRoofingFeatures;

  if (!_.isEmpty(featuresSubset)) {
    consideredFeatures = _.filter(consideredFeatures, f => featuresSubset.includes(f.key));
  }

  for (const feature of consideredFeatures) {
    if (feature.shouldShowFlag(item)) {
      shingleFeatures.unshift(feature);
    }
  }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <FeatureFlags className={className} {...props}>
      {shingleFeatures.map((f, idx) => (
        <FeatureSubImage item={item} key={idx} t={t} feature={f} />
      ))}
    </FeatureFlags>
  );
});
